export default "__VITE_ASSET__r_mskJ6F__"